export default "__VITE_ASSET__91fae2fb__"